module.exports = __webpack_public_path__ + "media/images/icon_price-c5e77391281a19700ea2822eb9ea27b0.png";